import defaultFn from './default';
import disabled from './disabled';
import error from './error';
import focus from './focus';

export default {
  default: defaultFn,
  disabled,
  focus,
  error,
};
